// extracted by mini-css-extract-plugin
module.exports = {"save-to-list-modal":"save-to-list-modal_save-to-list-modal__lUiBw","alert-box":"save-to-list-modal_alert-box__6hNJD"};